/**
 * The type scale. Sizes are deltas on `--ui-size` (see `styles/type.css`),
 * so a preference moves text, icons and controls together.
 */
export const UI_SIZE_CHOICES = [12, 13, 14, 15] as const
export type UiSize = (typeof UI_SIZE_CHOICES)[number]
export const DEFAULT_UI_SIZE: UiSize = 13

export const TYPE_ROLES = ['micro', 'caption', 'ui', 'body', 'title'] as const
export type TypeRole = (typeof TYPE_ROLES)[number]

/** Icon steps for marks that stand alone. A mark beside text sizes from it at 1.1em. */
export const ICON_STEP = {
  xs: 'var(--icon-xs)',
  sm: 'var(--icon-sm)',
  md: 'var(--icon-md)',
  lg: 'var(--icon-lg)',
} as const

export type IconSize = 'text' | keyof typeof ICON_STEP

/** Warns in development if the CSS default and this file disagree. Call before applying preferences. */
export function assertScaleDefaults(development: boolean): void {
  if (!development || typeof window === 'undefined') return
  const declared = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ui-size'))
  if (declared !== DEFAULT_UI_SIZE) {
    console.error(`[ui/tokens] styles/type.css declares --ui-size ${declared}px, typography.ts says ${DEFAULT_UI_SIZE}px.`)
  }
}
